module.exports = __webpack_public_path__ + "static/media/incident-grey.00d536e2.svg";